module.exports = __webpack_public_path__ + "static/media/np.37f3f442.svg";